// extracted by mini-css-extract-plugin
export var breadcrumb = "OtPVC";
export var breadcrumbItem = "cdZ4Q";
export var disabledLink = "NQ46F";
export var link = "_7MQWg";